/**
 * Mobile header menu — hamburger toggle (Figma Navigation 169:627).
 */
(function () {
  const MQ = '(max-width: 989px)';

  function isMobile() {
    return window.matchMedia(MQ).matches;
  }

  function initToggle(btn) {
    const wrap = btn.closest('.gearby-chrome__header-wrap');
    let menu =
      wrap && wrap.querySelector('.gearby-chrome__mobile-menu');
    if (!menu) {
      const menuId = btn.getAttribute('aria-controls');
      if (menuId) menu = document.getElementById(menuId);
    }
    if (!menu) return;

    function close() {
      btn.setAttribute('aria-expanded', 'false');
      menu.hidden = true;
      document.documentElement.classList.remove('gearby-menu-open');
    }

    function open() {
      btn.setAttribute('aria-expanded', 'true');
      menu.hidden = false;
      if (isMobile()) {
        document.documentElement.classList.add('gearby-menu-open');
      }
    }

    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        close();
      } else {
        open();
      }
    });

    menu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', close);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') {
        close();
      }
    });

    document.addEventListener('click', (e) => {
      if (btn.getAttribute('aria-expanded') !== 'true') return;
      if (btn.contains(e.target) || menu.contains(e.target)) return;
      close();
    });

    window.matchMedia(MQ).addEventListener('change', (ev) => {
      if (!ev.matches) close();
    });
  }

  document.querySelectorAll('[data-gearby-menu-toggle]').forEach(initToggle);
})();
